const songGenres = [
  "Pop: pop edm mournful keys and atmospheric synths bass heavy drop",
  "Rock: electric punk dance rock",
  "Afrobeat: Afrobeat, synth pop, syncopation, groove, FEMALE VOCALS, major chords, Melodic techno, Electronic, Afrobeat, syncopation, djembe, four by the floor, grimy, dark, syncopation",
  "Epic: Epic power vocals, epic backing choir, power metal epic",
  "Soul: trap hip hop soul funk modern pop",
  "Hypnotic: experimental, electronica, minimal, soft female vocals, deep bass, hypnotic electronic beats, pulsing basslines, expressive rubato, binaural, emotive, memorable, heart-pounding",
  "Metal: cyber metal, clean vocals, screamed vocals, electronic elements, guitar stings, virtuosic guitar riffs",
  "Lofi: lofi chillhop emotional dream",
  "Retro: retro Italo-disco, 80s synth-pop",
  "Rap: rap, gangsta rap, bright, trap, melodic rap"
];

export default songGenres